import moment from 'moment';
import 'moment/locale/ja';
import Decimal from 'decimal.js';
import { PaginationType } from 'src/components/common/Pagin';

export const getToday = (formatDate: string = 'YYYY/MM/DD') => {
  const date = moment();
  const currentDate = date.format(formatDate);
  return currentDate;
};

export const getDayOfWeek = () => {
  const dayOfWeek = moment().format('dddd');
  return dayOfWeek;
};

export const isToday = (day: string) => {
  const date = moment();
  const currentDate = date.format('YYYY/MM/DD');
  return currentDate === day;
};

export const getDetailPagin = (pagination: PaginationType) => {
  return `${(pagination.page - 1) * pagination.pagesize + 1}-${
    pagination.pages === 1
      ? pagination.total
      : pagination.page * pagination.pagesize
  }/${pagination.total}`;
};

export const isEmpty = (data: string | number | null) => {
  if (data || data === 0) {
    return false;
  }
  return true;
};

export const generateRandomString = (length: number): string => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const getField = (item: any, name: string, defaultVal: any = '-') => {
  return item && (item[name] || item[name] === 0) ? item[name] : defaultVal;
};

export const formatNumber = (number: number): string => {
  return new Intl.NumberFormat('en-US').format(number);
};

export const roundUpFnc = (value: number, unit: number) => {
  if (value < 1000) {
    return Math.ceil(value / 100) * 100;
  }
  return Math.ceil(value / unit) * unit;
};

export const roundDownFnc = (value: number, unit: number) => {
  return Math.floor(value / unit) * unit;
};

export const formatQuotaionNumber = (id: number): string => {
  return id.toString().padStart(8, '0');
};

export const formatDateForInput = (date: any) => {
  return date.toISOString().split('T')[0];
};

export const formatDateTimeFromISO = (date: string) => {
  return moment(date).format('YYYY-MM-DD h:mm:ss');
};

export const sortObject = (unsortedObject: any, key: string = 'order') => {
  return unsortedObject.sort((a: any, b: any) => {
    if (a[key] < b[key]) {
        return -1;
    }
    if (a[key] > b[key]) {
        return 1;
    }
    return 0;
});
};

export const caluculateTax = (amount: number, rate: number = 0.1) => {
  if (amount == null) {
    // console.error('Invalid amount:', amount);
    return 0;
  }
  
  const decimalAmount = new Decimal(amount);
  const decimalRate = new Decimal(rate);

  const divisor = new Decimal(1).plus(decimalRate);
  const resultDecimal = decimalAmount.times(decimalRate).dividedBy(divisor).floor();

  return resultDecimal.toNumber();
}



export const getPatientIcon = (icon: any) => {
  let name = '';
  switch (icon.namej) {
    case '♡':
      name = `/images/icons/ic-patient-heart${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    case '☆':
      name = `/images/icons/ic-patient-star${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    case '◇':
      name = `/images/icons/ic-patient-line${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    case '⚠':
      name = `/images/icons/ic-patient-warning${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    case '后':
      name = `/images/icons/ic-patient-post-question${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    case '禁':
      name = `/images/icons/ic-patient-forbidden${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    case 'assignment':
      name = `/images/icons/ic-patient-note${icon.active === 1 ? '-active' : ''}.svg`;
      break;
    default:
      break;
  }
  return name;
}